import styled from "styled-components";

export const PoweredByTextBox = styled.span`
  color: #007cf7;
  margin-top: auto;
  font-size: 1.2rem;
`;